import { gsap } from 'gsap';

export default class Logo {

	constructor(el) {
		this.logo = el;

		if(!this.logo) {
			return;
		}

		this.chars = el.querySelectorAll('[data-weight]');

        this.logo.addEventListener('mouseenter', () => {
            this.chars.forEach((char) => {
                const weight = char.getAttribute('data-weight');
                const targetWeight = 800 - weight;
                gsap.to(char, {
                    '--weight': targetWeight,
                    duration: 0.3,
                    ease: 'sine.inOut',
                });
            });
        });

        this.logo.addEventListener('mouseleave', () => {
            this.chars.forEach((char) => {
                const targetWeight = char.getAttribute('data-weight');
                gsap.to(char, {
                    '--weight': targetWeight,
                    duration: 0.3,
                    ease: 'sine.inOut',
                });
            });
        });
	}
}